import { directus } from "@/lib/directus"
import { User } from "@/types/models/user"
import { readMe, updateMe } from "@directus/sdk"
import type { UserRepository } from "@/lib/repositories/interfaces/user-repository.interface"

const ME_FIELDS = [
  "*",
  "role.name",
  "tenants.*",
  "tenants.tenants_id.*",
  "tenants.tenants_id.translations.*",
  "active_tenant.*",
  "active_tenant.translations.*",
  "active_tenant.areas_comarcales.*",
  "active_tenant.ambitos_intervencion.*",
  "active_tenant.municipios.*",
] as const

export async function fetchCurrentUserRepository() {
  return await directus.request(
    readMe({
      fields: [...ME_FIELDS],
      deep: {
        active_tenant: {
          municipios: {
            _limit: -1,
            _sort: "nombre",
          },
        },
      },
    })
  )
}

export async function loginRepository(email: string,password: string) {
  return await directus.login({ email, password },{ mode: "session" }
)
}

export async function logoutRepository() {
  return await directus.logout({ mode: "session" })
}

export async function updateCurrentUserRepository(patch: Partial<User>) {
  return await directus.request(updateMe(patch as any))
}

export async function setActiveTenantRepository(tenantId: number) {
  return await directus.request(updateMe({ active_tenant: tenantId } as any))
}

export const userRepository: UserRepository = {
  fetchCurrentUser: fetchCurrentUserRepository,
  login: loginRepository,
  logout: logoutRepository,
  updateCurrentUser: updateCurrentUserRepository,
  setActiveTenant: setActiveTenantRepository,
}
